import { defineComponent as _defineComponent } from 'vue'
import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingView',
  setup(__props) {

const BOOKING_HOOK_WIDGET_ID = '1939632100';
const BOOKING_HOOK_SCRIPT_ID = 'bookinghook-script';
const bookingWidget = ref<HTMLElement | null>(null);
const isWidgetLoading = ref(true);

const loadBookingHookWidget = async () => {
    await nextTick();
    isWidgetLoading.value = true;

    if (bookingWidget.value) {
        // Reset container so the external script can render again on route revisits.
        bookingWidget.value.innerHTML = '';
    }

    const existingScript = document.getElementById(BOOKING_HOOK_SCRIPT_ID);
    if (existingScript) {
        existingScript.remove();
    }

    const script = document.createElement('script');
    script.id = BOOKING_HOOK_SCRIPT_ID;
    script.type = 'text/javascript';
     script.src = `https://www.bookinghook.com/js/bookinghook.js?id=${BOOKING_HOOK_WIDGET_ID}`;
    script.async = true;
    script.onload = () => {
        isWidgetLoading.value = false;
    };
    script.onerror = () => {
        isWidgetLoading.value = false;
    };

    document.body.appendChild(script);
};

onMounted(() => {
    loadBookingHookWidget();
});

onBeforeUnmount(() => {
    isWidgetLoading.value = true;
    const existingScript = document.getElementById(BOOKING_HOOK_SCRIPT_ID);
    if (existingScript) {
        existingScript.remove();
    }
});

return { __sfc: true,BOOKING_HOOK_WIDGET_ID, BOOKING_HOOK_SCRIPT_ID, bookingWidget, isWidgetLoading, loadBookingHookWidget }
}

})